import React from 'react';
import { StyleSheet, css } from 'aphrodite';

import RateQuote from './RateQuote';
import RateEntry from './RateEntry';

const RateQuoteGenerator = () => (
  <div>
    <div className={css(styles.rateQuoteContainer)}>
      <RateEntry className={css(styles.rateQuoteCard)} />
      <RateQuote className={css(styles.rateQuoteCard)} />
    </div>
  </div>
);

export default RateQuoteGenerator;

const styles = StyleSheet.create({
  rateQuoteContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingRight: 15,
  },
  rateQuoteCard: {
    marginTop: 15,
    marginLeft: 15,
    '@media (min-width: 925px)': {
      maxWidth: 'calc(50% - 15px)',
      minWidth: 'calc(50% - 15px)',
    },
    '@media (max-width: 925px)': {
      maxWidth: 'calc(100% - 15px)',
      minWidth: 'calc(100% - 15px)',
    },
  },
});



// WEBPACK FOOTER //
// /src/components/RateQuoteGenerator/RateQuoteGenerator.js